<template>
    <PageView>
        <a-spin :spinning="loading1">
            <div class="new-page">
                <div class="new-times">
                    <div class="flex-first">
                        <span>实时数据</span>
                    </div>
                    <div class="felx-end">
                        <span>选择日期</span>
                        <a-range-picker :value="timeRange" @change="handleRangeChange" />
                    </div>
                </div>
                <div class="index-block">
                    <div class="block-item bg5">
                        <div class="item-img">
                            <img src="https://zuji.ahxunbu.com/images/5.png" alt="">
                        </div>
                        <div class="item-title">
                            <span class="item-text">今日UV数</span>
                            <span class="item-num">{{ topTitle.today_user_num }}</span>
                        </div>
                    </div>
                    <div class="block-item bg1">
                        <div class="item-img">
                            <img src="https://zuji.ahxunbu.com/images/1.png" alt="">
                        </div>
                        <div class="item-title">
                            <span class="item-text">昨日UV数</span>
                            <span class="item-num">{{ topTitle.day1_user_num }}</span>
                        </div>
                    </div>
                    <div class="block-item bg3">
                        <div class="item-img">
                            <img src="https://zuji.ahxunbu.com/images/3.png" alt="">
                        </div>
                        <div class="item-title">
                            <span class="item-text">前日UV数</span>
                            <span class="item-num">{{ topTitle.day2_user_num }}</span>
                        </div>
                    </div>
                    <div class="block-item bg4">
                        <div class="item-img">
                            <img src="https://zuji.ahxunbu.com/images/4.png" alt="">
                        </div>
                        <div class="item-title">
                            <span class="item-text">近3日UV总数</span>
                            <span class="item-num">{{ topTitle.day3_user_num }}</span>
                        </div>
                    </div>
                    <div class="block-item bg5">
                        <div class="item-img">
                            <img src="https://zuji.ahxunbu.com/images/5.png" alt="">
                        </div>
                        <div class="item-title">
                            <span class="item-text">近7日UV总数</span>
                            <span class="item-num">{{ topTitle.day7_user_num }}</span>
                        </div>
                    </div>
                    <div class="block-item bg6">
                        <div class="item-img">
                            <img src="https://zuji.ahxunbu.com/images/6.png" alt="">
                        </div>
                        <div class="item-title">
                            <span class="item-text">近15日UV总数</span>
                            <span class="item-num">{{ topTitle.day15_user_num }}</span>
                        </div>
                    </div>

                    <div class="block-item bg4">
                        <div class="item-img">
                            <img src="https://zuji.ahxunbu.com/images/4.png" alt="">
                        </div>
                        <div class="item-title">
                            <span class="item-text">近30日UV总数</span>
                            <span class="item-num">{{ topTitle.day30_user_num }}</span>
                        </div>
                    </div>

                    <div class="block-item bg1">
                        <div class="item-img">
                            <img src="https://zuji.ahxunbu.com/images/6.png" alt="">
                        </div>
                        <div class="item-title">
                            <span class="item-text">本月UV数</span>
                            <span class="item-num">{{ topTitle.day31_user_num }}</span>
                        </div>
                    </div>

                    <div class="block-item bg2">
                        <div class="item-img">
                            <img src="https://zuji.ahxunbu.com/images/2.png" alt="">
                        </div>
                        <div class="item-title">
                            <span class="item-text">上月UV数</span>
                            <span class="item-num">{{ topTitle.day60_user_num }}</span>
                        </div>
                    </div>

                    <div class="block-item bg4">
                        <div class="item-img">
                            <img src="https://zuji.ahxunbu.com/images/3.png" alt="">
                        </div>
                        <div class="item-title">
                            <span class="item-text">总UV数</span>
                            <span class="item-num">{{ topTitle.total_user_num }}</span>
                        </div>
                    </div>

                </div>
            </div>

            <div class="new-order-flex">
                <div class="new-top-center">
                    <div class="order-title">
                        <span>待审核({{ topTitle.orders_repay_num }})</span>
                    </div>
                    <div>
                        <a-table
                            :loading="loading2"
                            :columns="columns"
                            :dataSource="dataone"
                            :pagination="{ total, pageSize, showSizeChanger, current }"
                            @change="changePagination"
                            bordered
                            :scroll="{ x: true }"
                        >
                        </a-table>
                    </div>
                </div>
                <div class="new-top-center">
                <div class="order-title">
                    <span>待归还({{ topTitle.orders_repay_num }})</span>
                </div>
                <div>
                    <a-table
                        :loading="loading2"
                        :columns="columns"
                        :dataSource="datafour"
                        :pagination="{ total, pageSize, showSizeChanger, current }"
                        @change="changePaginationfour"
                        bordered
                        :scroll="{ x: true }"
                    >
                    </a-table>
                </div>
                </div>
            </div>
            <div class="new-bottom">
                <div class="new-title">
                    <span>归还成功</span>
                </div>
                <div>
                    <a-table
                        :loading="loading2"
                        :columns="columns"
                        :dataSource="datafive"
                        :pagination="{ total, pageSize, showSizeChanger, current }"
                        @change="changePaginationfive"
                        bordered
                        :scroll="{ x: true }"
                    >
                    </a-table>
                </div>
            </div>
        </a-spin>
    </PageView>
</template>

<script>
import Config from '../../api/Config';
var moment = require('moment');
export default {
    name: 'index',
    data() {
        return {
            timeRange: [],
            newTime:[],
            loading1: false,
            loading2:true,
            topTitle:{},
            dataone:[],
            datafour:[],
            datafive:[],
            columns: [
              {
                    title: '下单时间',
                    dataIndex: 'add_time',
                    customRender: (v) => {
                        return v ? this.timeOne(v) : '暂无'
                    }
                },
                {
                    title: '订单号',
                    dataIndex: 'orderno'
                },
                {
                    title: '收货地址',
                    customRender:(v)=>{
                        return v.order_type==2?v.add_ress ? v.add_ress.pro_str + v.add_ress.add_ress : '空':'暂无'
                    }
                },
                {
                    title: '收货人姓名',
                    customRender:(v)=>{
                        return v.order_type==2?v.add_ress?v.add_ress.name:'空':'暂无'
                    }
                },
                {
                    title: '收货人手机号',
                    customRender:(v)=>{
                        return v.order_type==2?v.add_ress?v.add_ress.phone:'空':'暂无'
                    }
                },
                {
                    title: '下单人',
                    dataIndex: 'name'
                },
                {
                    title: '下单人手机号',
                    dataIndex: 'phone'
                },
                {
                    title: '预计归还日期',
                    dataIndex: 'end_time',
                    customRender:(v)=>{
                        return v?this.timeOne(v):'暂无'
                    }
                },
            ],
        }
    },
    activated() {
        this.GetInfo();
    },
    methods: {
        GetInfo(time) {
            Config.agentNumber({time:time}).then(res => {
                this.topTitle = res.data;
                this.getListone();
                this.getListfour();
                this.getListfive();
            })
        },
        handleRangeChange(value) {
            if (Array.isArray(value) && value.length === 2) {
                    const validDates = value.every(date => date instanceof moment || date instanceof Date);
                    if (validDates) {
                        this.timeRange = value;
                        const startTimeStamp = moment(this.timeRange[0]).valueOf();
                        const endTimeStamp = moment(this.timeRange[1]).valueOf();
                        this.newTime = [parseInt(startTimeStamp/1000),parseInt(endTimeStamp/1000)]
                        this.GetInfo(this.newTime)
                    } else {
                    // 处理日期类型错误的情况
                    console.log('进入2')

                    }
            } else {
                this.newTime =[];
                this.GetInfo(this.newTime)
                    // 处理长度不为2的情况
                    console.log('进入1')
            }

        },
        getListone(){
            // type 1 待审核  4待归还 5 归还成功
            Config.orderIndexList({
                type:1
            }).then(res => {
                this.loading2 = false;
                this.dataone = res.result;
            })
        },
        getListfour(){
            // type 1 待审核  4待归还 5 归还成功
            Config.orderIndexList({
                type:4
            }).then(res => {
                this.loading2 = false;
                this.datafour = res.result;
            })
        },
        getListfive(){
            // type 1 待审核  4待归还 5 归还成功
            Config.orderIndexList({
                type:5
            }).then(res => {
                this.loading2 = false;
                this.datafive = res.result;
            })
        },
        changePagination (pagination) {
            Object.keys(pagination).forEach(val => {
                this[val] = pagination[val]
            })
            this.getListone();
        },
        changePaginationfour(){
            Object.keys(pagination).forEach(val => {
                this[val] = pagination[val]
            })
            this.getListfour();
        },
        changePaginationfive(){
            Object.keys(pagination).forEach(val => {
                this[val] = pagination[val]
            })
            this.getListfive();
        }
    }
}
</script>

<style scoped lang="less">
.new-page{
    padding: 30px;
    background: #fff;
    margin-bottom: 20px;
    .new-times{
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        align-content: center;
        .flex-first{
            span{
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: bold;
                color: #000000;
            }
        }
        .felx-end{
            span{
                margin-right: 10px;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #000000;
            }
        }
    }
}
.index-block{
    display: flex;
    flex-wrap:wrap;
    .block-item{
        margin: 20px;
        width: 200px;
        height: 150px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .bg1{
        background: linear-gradient(90deg, #2591EF, #60BAEA);

    }
    .bg2{
        background: linear-gradient(90deg, #07AEC6, #70DCE6);
    }
    .bg3{
        background: linear-gradient(90deg, #F28662, #F8BFB1);
    }
    .bg4{
        background: linear-gradient(90deg, #4788FF, #82AEFE);
    }
    .bg5{
        background: linear-gradient(90deg, #45BEB0, #98D9D1);
    }
    .bg6{
        background: linear-gradient(90deg, #8674FE, #B7ACFF);
    }
}
.item-img{
    margin: 5px;
    img{
        width: 50px;
        height: 50px;
    }
}
.item-title{
    margin: 5px;

    display: flex;
    flex-direction: column;
    .item-text{
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #FFFFFF;
    }
    .item-num{
        font-size: 14px;
        font-family: Arial;
        font-weight: bold;
        color: #FFFFFF;
    }
}
.new-top{
    background: #fff;
    padding: 20px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .new-flex{
        display: flex;
        align-items: center;
        .flex-block{
            margin-right: 30px;
            .title-text{
                font-size: 20px;
                font-weight: bold;
            }
            .title-num{
                font-size: 20px;
            }
        }
    }
    .new-title{
        margin-bottom: 10px;
            span{
                font-weight: bold;
            }
    }
    .new-times{
        .felx-end{
            .new-text{
                margin-right: 10px;
                font-size: 20px;
            }
        }
    }
}
.new-order-flex{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    .new-top-center{
        width: 49%;
        height: 400px;
        background: #fff;
        padding: 20px;
        overflow-y: scroll;
        .order-title{
            margin-bottom: 10px;
            span{
                font-weight: bold;
            }
        }
}
}
.new-bottom{
    background: #fff;
    padding: 20px;
    .new-title{
        margin-bottom: 10px;
            span{
                font-weight: bold;
            }
    }
}

</style>
